// extracted by mini-css-extract-plugin
export default {"labelClass":"ClaimantInformationInputComponent_labelClass__PeVc5"};